import type { DriveFolderPermission, DriveFolderReference, DriveFolderSetting } from '../drive/types';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Invalid stored references stay invalid; a path is never a fallback. */
export function readDriveFolderSetting(value: unknown): DriveFolderSetting | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const ref = value as Record<string, unknown>;
  if (ref.type !== 'drive.folder' || typeof ref.mountId !== 'string' || !/^[1-9]\d*$/.test(ref.mountId)) return null;
  if (typeof ref.documentId !== 'string' || !UUID.test(ref.documentId) || /^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(ref.documentId)) return null;
  if (ref.permission !== 'read' && ref.permission !== 'write') return null;
  if (ref.companyId !== undefined && (typeof ref.companyId !== 'string' || !UUID.test(ref.companyId))) return null;
  return { type: 'drive.folder', mountId: ref.mountId, documentId: ref.documentId, permission: ref.permission,
    ...(typeof ref.companyId === 'string' ? { companyId: ref.companyId } : {}),
  };
}

export function driveFolderSetting(folder: DriveFolderReference, permission: DriveFolderPermission): DriveFolderSetting {
  const stored = readDriveFolderSetting({ type: 'drive.folder', ...folder, permission });
  if (!stored) throw new Error('Invalid Drive folder reference');
  return stored;
}

export function sameDriveFolder(a: DriveFolderReference | null | undefined, b: DriveFolderReference | null | undefined): boolean {
  return Boolean(a && b && a.mountId === b.mountId && a.documentId.toLowerCase() === b.documentId.toLowerCase());
}
